import { useEffect } from 'react';

import { useApprovalFlowStatus } from '../api/queries/index.js';
import { useApprovalFlowContext } from '../context.jsx';

type Options = {
  approvalItemId: string;
  approvalItemType: string;
};

export const usePopulateApprovalFlowContext = ({
  approvalItemId,
  approvalItemType,
}: Options) => {
  const { data } = useApprovalFlowStatus({ approvalItemId, approvalItemType });
  const { setApprovalFlowData } = useApprovalFlowContext();

  useEffect(() => {
    if (!data) {
      return;
    }

    setApprovalFlowData({
      ...data,
      approvalItemId,
      approvalItemType,
      approvalProcessId: data.approvalProcessId ?? '',
    });
  }, [data, approvalItemId, approvalItemType, setApprovalFlowData]);
};
